import { isProd } from "utils/env";

export const missionId = window.location.pathname.split("/")[1];

const multiMissionUrls = {
  myIdConfirmationSamePassword: "/:missionId/login/my-id-confirmation-mms",
  myIdEmailVerification: "/:missionId/login/my-id-mm-email-verification",
  myIdSetPassword: "/:missionId/login/my-id-mm-set-password",
  myIdConfirmationDiffPassword: "/:missionId/login/my-id-confirmation-mmd",
  multiMissionCompleteLink: "/:missionId/login/my-id-mm-complete",
};

export const urls = {
  login: "/:missionId/login",
  otp: "/:missionId/login/mfa",
  webAuthnRegister: "/:missionId/webauthn-registration",
  webAuthnAssertionFinish: "/:missionId/webauthn/assertion/finish",
  sendOtpCode: "/:missionId/login/send-mfa",
  activateAccount: "/:missionId/activate/:token",
  forgottenPassword: "/:missionId/forgotten-password",
  forgottenPasswordOtp: "/:missionId/password/verify-otp",
  initiateAccountRecovery: "/:missionId/account-recovery/verify-details",
  accountRecoveryOtp: "/:missionId/account-recovery/otp",
  resetPassword: "/:missionId/reset-password/:token?",
  resetPasswordNoToken: "/:missionId/reset-password",
  initiateRegistration: "/:missionId/email-verification",
  registrationOtp: "/:missionId/register/mfa",
  register: "/:missionId/register/:token",
  findOutMore: "/:missionId/find-out-more-about-myid",
  progressiveRegistration: "/:missionId/progressive-registration",
  keepYourAccountSafe: "/:missionId/keep-your-account-safe",

  ...multiMissionUrls,
};

export const getUrl = (urlKey) => urls[urlKey].replace(":missionId", missionId);

export const getLoginLink = () => {
  return urls.login.replace(":missionId", missionId);
};

export const getWebAuthnRegisterLink = () => {
  return urls.webAuthnRegister.replace(":missionId", missionId);
};

export const getMyIdConfirmationSamePasswordLink = () =>
  urls.myIdConfirmationSamePassword.replace(":missionId", missionId);

export const getMyIdConfirmationDiffPasswordLink = () =>
  urls.myIdConfirmationDiffPassword.replace(":missionId", missionId);

export const getInitiateRegistrationLink = () => {
  return urls.initiateRegistration.replace(":missionId", missionId);
};

export const getRegistrationOtpLink = () => {
  return urls.registrationOtp.replace(":missionId", missionId);
};

export const getRegistrationLink = (token) => {
  return urls.register
    .replace(":missionId", missionId)
    .replace(":token", token);
};

export const getForgottenPasswordLink = () => {
  return urls.forgottenPassword.replace(":missionId", missionId);
};

export const getForgottenPasswordOtpLink = () => {
  return urls.forgottenPasswordOtp.replace(":missionId", missionId);
};

export const getSendOtpCodeLink = () => {
  return urls.sendOtpCode.replace(":missionId", missionId);
};

export const getFindOutMoreLink = () => {
  return urls.findOutMore.replace(":missionId", missionId);
};

export const getKeepYourAccountSafeUrl = () => {
  return urls.keepYourAccountSafe.replace(":missionId", missionId);
};

export const getMultiMissionCompleteLink = () => {
  return urls.multiMissionCompleteLink.replace(":missionId", missionId);
};

export const getInitiateAccountRecoveryLink = () => {
  return urls.initiateAccountRecovery.replace(":missionId", missionId);
};

export const getAccountRecoveryOtpLink = () => {
  return urls.accountRecoveryOtp.replace(":missionId", missionId);
};

export const getResetPasswordLink = () => {
  return urls.resetPassword.replace(":missionId", missionId);
};

export const getResetPasswordLinkNoToken = () => {
  return urls.resetPasswordNoToken.replace(":missionId", missionId);
};

export const isMultiMissionUrl = (url) => {
  return Object.values(multiMissionUrls).some(
    (multiMissionValue) =>
      multiMissionValue.replace(":missionId", missionId) === url
  );
};

export const isLoginUrl = (url) => {
  return urls.login.replace(":missionId", missionId) === url;
};

export const getNectarRegisterUrl = () => {
  return isProd()
    ? "https://www.nectar.com/register"
    : "https://nectar.pianoinfradev.com/register";
};
